import React, { useEffect, useState } from "react";
import ModalComponent from "common/components/Model";
import MDBox from "common/components/MDBox";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MDButton from "common/components/MDButton";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { saveEmployee } from "services/employee/employee";
import { getEmployeeList } from "services/employee/employee";
import { updateEmployee } from "services/employee/employee";

const Toast = Swal.mixin({
    toast: true,
    position: "top",
    zIndex: 10,
    showConfirmButton: false,
    timer: 2000,
    onOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
});

const AddEmployeeModel = ({ setShowModal, showModal, updateData, currentPage, update=false }) => {

    const dispatch = useDispatch()
    const [name, setName] = useState(update ? updateData.full_name : "");
    const [number, setNumber] = useState(update ? updateData.phone : "");
    const [nic, setNic] = useState(update ? updateData.nic : "");
    const [email, setEmail] = useState(update ? updateData.email : "");
    const [address, setAddress] = useState(update ? updateData.address : "");
    const [nicError, setNicError] = useState("");
    const [contactNoError, setContactNoError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [saveLoader, setSaveLoader] = useState(false);

    const saveEmployeeSlice = useSelector((state) => state.saveEmployeeSlice.employee);
    const updateEmployeeSlice = useSelector((state) => state.updateEmployeeSlice.employee);

    const handleNicNoChange = (e) => {
        setNic(e.target.value);
        if (!/^([0-9]{9}[x|X|v|V]|[0-9]{12})$/.test(e.target.value)) {
            setNicError("Invalid NIC number");
        } else {
            setNicError("");
        }
    };
    const handleContactNoChange = (e) => {
        setNumber(e.target.value);
        if (!/^(\+94|0)\d{9}$/.test(e.target.value)) {
            setContactNoError("Invalid mobile number");
        } else {
            setContactNoError("");
        }
    };
    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        if (
            !/^([a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/.test(e.target.value)
        ) {
            setEmailError("Invalid Email Address");
        } else {
            setEmailError("");
        }
    };

    const clearText = () => {
        setName("");
        setNumber("");
        setNic("");
        setEmail("");
        setAddress("");
    };

    const submitEmployeeDetails = () => {
        if (update) {
            const payload = {
                full_name: name,
                address: address,
                phone: number,
                email: email,
                nic: nic,
            }
            setSaveLoader(true);
            dispatch(updateEmployee({id: updateData.emp_id, page: payload}))
        } else {
            const payload = {
                full_name: name,
                address: address,
                phone: number,
                email: email,
                nic: nic,
            }
            setSaveLoader(true)
            dispatch(saveEmployee(payload))
        }
    }

    useEffect(() => {
        if (saveLoader) {
            if (!saveEmployeeSlice.isLoading && saveEmployeeSlice.isSuccess) {
                setSaveLoader(false);
                clearText();
                setShowModal(false);
                dispatch(getEmployeeList({ page: currentPage }));
                Toast.fire({
                    icon: "success",
                    title: "Employee Save Successfully",
                });
            } else if (saveEmployeeSlice.isError) {
                Toast.fire({
                    icon: "error",
                    title: "Invalid Input",
                });
            }
        }
    }, [saveEmployeeSlice.data]);

    useEffect(() => {
        if (saveLoader) {
            if (!updateEmployeeSlice.isLoading && updateEmployeeSlice.isSuccess) {
                setSaveLoader(false);
                clearText();
                setShowModal(false);
                dispatch(getEmployeeList({ page: currentPage }));
                Toast.fire({
                    icon: "success",
                    title: "Employee Update Successfully",
                });
            } else if (updateEmployeeSlice.isError) {
                Toast.fire({
                    icon: "error",
                    title: "Invalid Input",
                });
            }
        }
    }, [updateEmployeeSlice.data]);

    return (
        <ModalComponent
            setShowModal={setShowModal}
            showModal={showModal}
            maxWidth={"md"}
        >
            <MDBox pb={3}
                sx={{
                    padding: { xs: 2, md: 6, },
                    paddingTop: { xs: 6, },
                }}
            >
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={6} xl={6}>
                        <TextField
                            id="outlined-helperText"
                            label="Full Name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} xl={6}>
                        <TextField
                            id="outlined-helperText"
                            label="Address"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} xl={6}>
                        <TextField
                            id="outlined-helperText"
                            label="Number"
                            value={number}
                            fullWidth
                            onChange={handleContactNoChange}
                            error={contactNoError !== ""}
                            helperText={contactNoError}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} xl={6}>
                        <TextField
                            id="outlined-helperText"
                            label="E-mail"
                            value={email}
                            onChange={handleEmailChange}
                            fullWidth
                            error={emailError !== ""}
                            helperText={emailError}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} xl={6}>
                        <TextField
                            id="outlined-helperText"
                            label="NIC"
                            value={nic}
                            onChange={handleNicNoChange}
                            fullWidth={true}
                            error={nicError !== ""}
                            helperText={nicError}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} xl={6}
                        sx={{
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" },
                            flexWrap: "nowrap",
                        }}
                    >
                        <Grid item xs={12} md={6} xl={6}
                            sx={{
                                paddingRight: { xs: 0, sm: "8px" },
                                paddingBottom: { xs: "8px", sm: 0 },
                            }}
                        >
                            {!updateData && (
                                <MDButton
                                    variant="outlined"
                                    color="secondary"
                                    fullWidth
                                    disabled={updateData}
                                    onClick={() => {
                                        clearText();
                                    }}
                                >
                                    Clear
                                </MDButton>
                            )}
                        </Grid>
                        <Grid item xs={12} md={6} xl={6}
                            sx={{
                                paddingLeft: { xs: 0, sm: "8px" },
                                paddingTop: { xs: "8px", sm: 0 },
                            }}
                        >
                            <MDButton
                                variant="gradient"
                                fullWidth
                                color="info"
                                disabled={name === "" || nic === "" || number === "" ||
                                    email === "" || address === "" ||
                                    nicError ||
                                    contactNoError ||
                                    emailError
                                }
                                onClick={() => submitEmployeeDetails()}
                            >
                                {updateData ? "Update" : "Add Employee"}
                            </MDButton>
                        </Grid>
                    </Grid>
                </Grid>
            </MDBox>
        </ModalComponent>
    );
};
export default AddEmployeeModel;
